import script from "./compGroupSummaryKpis.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupSummaryKpis.vue?vue&type=script&setup=true&lang=js"

import "./compGroupSummaryKpis.vue?vue&type=style&index=0&id=bc3cfe92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc3cfe92"]])

export default __exports__